import { Experience, TechType } from './Utility/types';

export const EMAIL = 'Build.Suraj@gmail.com';

export const GITHUB_URL = 'https://github.com/Suraj-Builds';

export const CURRENT_RESUME = 'My Resume.pdf';

export const experiences: Experience[] = [
  {
    id: '1',
    title: 'Full Stack Software Developer',
    company: 'Aether Enterprise Applications LLP',

    startDate: '2021-11-15',
    endDate: null,

    icon: 'AE',
    iconBg: 'bg-gradient-to-br from-teal-500 to-cyan-600',

    achievements: [
      'Developed an Auto-Logout function after a set period of inactivity for banking applications specialized for Accounting of Law Firms.',
      "Researched and selected the finest React package for data visualization, then implemented the whole data visualization application for law firms' accounting and cash flow.",
      "Upgraded the bank's whole front-end stack from React 16 to React 18",
      'Created a function that would generate a Digital Balance Sheet based on the Transactional Activity of law firms.',
      "Built a complete user flow for law firms' Official Cheque dashboard and Official Cheque creation in react framework.",
      'Created a feature that allows users to manually add Accounts and import Transactions into those accounts using a CSV file.',
      'Created a feature that allows users to upload cheque images for transactions, send those images to the back end for storage, and retrieve those cheque images.',
      'Created a feature for Digital Invoicing and Billing that allows law firms to create bills for their services.',
      'Used the Thymeleaf Template Engine to create the ability to download PDF reports.',
      'Developed a variety of APIs, constructed backend business logic, and created JUnits for those business logic with more than 95% coverage.',
    ],
    technologies: [
      { name: 'React', type: TechType.FRONTEND, proficiency: 4 },
      { name: 'Redux', type: TechType.FRONTEND, proficiency: 5 },
      { name: 'Formik', type: TechType.FRONTEND, proficiency: 5 },
      { name: 'Spring Boot', type: TechType.BACKEND, proficiency: 4 },
      { name: 'PostgreSQL', type: TechType.DATABASE, proficiency: 4 },
      { name: 'Material UI', type: TechType.FRONTEND, proficiency: 4 },
      { name: 'Hibernate', type: TechType.BACKEND, proficiency: 3 },
      {
        name: 'Thymeleaf Template Engine',
        type: TechType.BACKEND,
        proficiency: 3,
      },
    ],
  },
  {
    id: '2',
    title: 'Senior Analyst',
    company: 'eClerx Services Limited',

    startDate: '2020-11-10',
    endDate: '2021-11-10',

    icon: 'eC',
    iconBg: 'bg-gradient-to-br from-purple-500 to-indigo-600',

    achievements: [
      'Spearheaded the website enhancements for a leading electrical company, providing a smooth user experience and optimal efficiency.',
      'Leveraged React.js, HTML, CSS, and Redux to implement critical frontend features, Spring-Boot for backend activities',
      "Proactively identified and resolved technical issues, ensuring the website's compatibility across multiple browsers and devices.",
      "Implemented Redux for state management, significantly improving the predictability and scalability of the application's frontend architecture.",
      'Conducted regular code reviews and performance optimizations to uphold coding standards and enhance website responsiveness.',
      'Actively participated in agile development processes, including sprint planning, stand-ups, and retrospectives, to drive continuous improvement and timely delivery of website updates.',
    ],
    technologies: [
      { name: 'React.js', type: TechType.FRONTEND, proficiency: 4 },
      { name: 'HTML', type: TechType.FRONTEND, proficiency: 5 },
      { name: 'CSS', type: TechType.FRONTEND, proficiency: 4 },
      { name: 'Redux', type: TechType.FRONTEND, proficiency: 5 },
      { name: 'Spring Boot', type: TechType.BACKEND, proficiency: 4 },
      { name: 'JavaScript', type: TechType.FRONTEND, proficiency: 4 },
      { name: 'Git', type: TechType.OTHER, proficiency: 4 },
    ],
  },
];

export const gradientAndTextColors = [
  {
    gradient:
      'from-blue-500/20 to-cyan-500/20 border-blue-400/30 hover:from-blue-500/30 hover:to-cyan-500/30 hover:border-blue-400/50',
    textColor: 'text-blue-300 group-hover:text-blue-200',
  },
  {
    gradient:
      'from-purple-500/20 to-pink-500/20 border-purple-400/30 hover:from-purple-500/30 hover:to-pink-500/30 hover:border-purple-400/50',
    textColor: 'text-purple-300 group-hover:text-purple-200',
  },
  {
    gradient:
      'from-green-500/20 to-emerald-500/20 border-green-400/30 hover:from-green-500/30 hover:to-emerald-500/30 hover:border-green-400/50',
    textColor: 'text-green-300 group-hover:text-green-200',
  },
  {
    gradient:
      'from-orange-500/20 to-red-500/20 border-orange-400/30 hover:from-orange-500/30 hover:to-red-500/30 hover:border-orange-400/50',
    textColor: 'text-orange-300 group-hover:text-orange-200',
  },
];
